import styled from "styled-components/macro";
import PropTypes from "prop-types";

import { COLOR_VALUES } from "shared/config/colors";
import { SPACING_VALUES } from "shared/config/spacing";
import { mediaQueries } from "shared/config/breakpoints";
import VStack from "shared/components/layout/stack/VStack";
import Text from "shared/components/data-display/text/Text";
import SecondaryButton from "shared/components/inputs/button/SecondaryButton";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import PrimaryButton from "shared/components/inputs/button/PrimaryButton";

const DEFAULT_MESSAGE = "There doesn't appear to be anything here.";

const Wrapper = styled(VStack)`
    border: 1px dashed ${COLOR_VALUES.Gray_5};
    border-radius: 4px;
    padding: ${SPACING_VALUES.Two};
    
    ${mediaQueries.small} {
        padding: ${SPACING_VALUES.One};
        margin: 0 ${SPACING_VALUES.One};
    }
`;

const ResponsiveText = styled(Text)`
    ${mediaQueries.small} {
        font-size: 14px;
        line-height: 1.3;
        padding: 0 ${SPACING_VALUES.Half};
    }
`;

const EmptyState = ({
    message = DEFAULT_MESSAGE,
    title = null,
    actionProps,
    actionPropsForPrimary,
    actionPropsForTernaryButton,
    ...rest
}) => (
    <Wrapper align="center" {...rest}>
        <ResponsiveText variant="Body_1_1" color="Gray_2" css="text-align: center">
            {title ? `There are no ${title} to show.` : message}
        </ResponsiveText>
        {actionProps && <SecondaryButton {...actionProps} />}
        {actionPropsForPrimary && <PrimaryButton {...actionPropsForPrimary} />}
        {actionPropsForTernaryButton && (
            <TertiaryButton {...actionPropsForTernaryButton} />
        )}
    </Wrapper>
);

EmptyState.propTypes = {
    message: PropTypes.string,
    title: PropTypes.string,
    actionProps: PropTypes.object,
    actionPropsForPrimary: PropTypes.object,
    actionPropsForTernaryButton: PropTypes.object,
};

export default EmptyState;
